module.exports = __webpack_public_path__ + "media/images/patent/x_14-ada068098dd5c0c13f2adeebcbfd037b.png";